import { cardsItems } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            精选内容
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            每日大赛精选图文内容，涵盖教程、故事和话题预告
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {cardsItems.map((item, idx) => (
              <div
                key={idx}
                className={`bg-background-50 border border-background-200/70 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-200/50 transition-colors ${
                  idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
                }`}
              >
                <div className={`flex ${idx === 0 ? 'flex-col sm:flex-row' : 'flex-col'}`}>
                  <div className={`relative overflow-hidden ${idx === 0 ? 'w-full sm:w-2/5' : 'w-full'} aspect-[16/10]`}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading={idx > 3 ? 'lazy' : undefined}
                    />
                    <span
                      className={`absolute top-3 left-3 px-2 py-0.5 text-xs font-semibold rounded-full ${tagColorMap[item.tagColor] || tagColorMap.primary}`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <div className={`p-4 md:p-5 flex flex-col justify-center ${idx === 0 ? 'flex-1' : ''}`}>
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">
                      {item.desc}
                    </p>
                    <span className="text-xs text-primary-600 font-medium">
                      {item.stat}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}